import { render, staticRenderFns } from "./dashboard-rigthbar.vue?vue&type=template&id=1c4f8b6e&scoped=true&"
import script from "./dashboard-rigthbar.vue?vue&type=script&lang=ts&"
export * from "./dashboard-rigthbar.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-rigthbar.vue?vue&type=style&index=0&id=1c4f8b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f8b6e",
  null
  
)

export default component.exports